
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class TipologieRisorseGrid extends Serenity.EntityGrid<TipologieRisorseRow, any> {
        protected getColumnsKey() { return TipologieRisorseColumns.columnsKey; }
        protected getDialogType() { return TipologieRisorseDialog; }
        protected getIdProperty() { return TipologieRisorseRow.idProperty; }
        protected getInsertPermission() { return TipologieRisorseRow.insertPermission; }
        protected getLocalTextPrefix() { return TipologieRisorseRow.localTextPrefix; }
        protected getService() { return TipologieRisorseService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected getButtons() {
            var buttons = super.getButtons();
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "refresh-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "column-picker-button"), 1);
            return buttons;
        }
    }
}